import { Badge } from "@/components/ui/badge";
import {
  RATE_SOURCE_TYPE_LABELS,
  RATE_STATUS_LABELS,
  type RateCardStatus,
  type RateSourceType,
} from "@/types/rate";

const SOURCE_VARIANT: Record<
  RateSourceType,
  "default" | "secondary" | "destructive" | "outline" | "urgent" | "info"
> = {
  collect: "default",
  prepaid: "secondary",
  spot: "info",
  lcl: "outline",
};

interface RateSourceBadgeProps {
  source: RateSourceType;
  className?: string;
}

export function RateSourceBadge({ source, className }: RateSourceBadgeProps) {
  return (
    <Badge variant={SOURCE_VARIANT[source]} className={className}>
      {RATE_SOURCE_TYPE_LABELS[source]}
    </Badge>
  );
}

const STATUS_VARIANT: Record<
  RateCardStatus,
  "default" | "secondary" | "destructive" | "outline" | "urgent" | "info"
> = {
  active: "default",
  partial: "info",
  superseded: "outline",
  expired: "urgent",
};

interface RateStatusBadgeProps {
  status: RateCardStatus;
  className?: string;
}

export function RateStatusBadge({ status, className }: RateStatusBadgeProps) {
  return (
    <Badge variant={STATUS_VARIANT[status]} className={className}>
      {RATE_STATUS_LABELS[status]}
    </Badge>
  );
}
